import { Component, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { DropDownFilterSettings } from '@progress/kendo-angular-dropdowns';
import { BaseAutocompleteComponent } from '../base-autocomplete.component';

@Component({
  selector: 'boi-multi-select',
  templateUrl: './multi-select.component.html',
  styleUrls: ['./multi-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: MultiSelectComponent,
      multi: true
    }
  ]
})
export class MultiSelectComponent extends BaseAutocompleteComponent {
  @Input() public itemDisplayKeys: Array<string>;
  @Input() public itemTagKeys: Array<string>;
  @Input() public forceRequired: boolean;

  public filterSettings: DropDownFilterSettings = { caseSensitive: false, operator: 'startsWith' };
  public popupSettings = { popupClass: 'multiselect-hide-selected' };

  public getItemDisplayKeys(item: any): any {
    return this.itemDisplayKeys.map((key) => item[key]).join(' ');
  }

  public getItemTagKeys(item: any): any {
    return this.itemTagKeys.map((key) => item[key]).join(' ');
  }
}
